import { ReactComponent as ClaudeCodeIcon } from 'Images/claude_code.svg';

import { PLACEHOLDER } from './placeholders';
import {
  AUTH_TOKEN,
  AUTH_USER_PASSWORD,
  BLOCK_COMMAND,
  CLIENT_STATUS_SUPPORTED
} from './constants';

const buildCommand = (authMethod) => {
  const credentials = authMethod === AUTH_USER_PASSWORD
    ? `--header "X-Faraday-Username: ${PLACEHOLDER.username}" \\\n--header "X-Faraday-Password: ${PLACEHOLDER.password}"`
    : `--header "X-Faraday-Token: ${PLACEHOLDER.apiToken}"`;

  return `claude mcp add --transport http faraday ${PLACEHOLDER.serverUrl} \\
--header "X-Faraday-URL: ${PLACEHOLDER.instanceUrl}" \\
${credentials}`;
};

const claudeCode = {
  id: 'claudeCode',
  label: 'Claude Code',
  icon: ClaudeCodeIcon,
  status: CLIENT_STATUS_SUPPORTED,
  authMethods: [AUTH_TOKEN, AUTH_USER_PASSWORD],
  summaryId: 'mcp.client.claudeCode.summary',
  buildSections: ({ authMethod }) => [
    {
      id: 'command',
      titleId: 'mcp.client.claudeCode.command.title',
      blocks: [
        {
          id: 'add-server',
          type: BLOCK_COMMAND,
          snippet: buildCommand(authMethod)
        }
      ]
    }
  ]
};

export default claudeCode;
